/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
/**
 * @deprecated Use icons from `@chilipiper/icons/figma-generated/src/icon` or
 *   `@chilipiper/icons/figma-generated/src/logo` instead
 */
export const SvgArrowRight = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.7082 3.66091C8.11658 3.25701 8.77506 3.26065 9.17896 3.66903L12.7394 7.26903C13.1401 7.67423 13.1401 8.32647 12.7394 8.73167L9.17896 12.3317C8.77506 12.7401 8.11658 12.7437 7.7082 12.3398C7.29981 11.9359 7.29618 11.2774 7.70007 10.869L9.50866 9.04035H3.99996C3.42558 9.04035 2.95996 8.57473 2.95996 8.00035C2.95996 7.42598 3.42558 6.96035 3.99996 6.96035H9.50866L7.70007 5.13167C7.29618 4.72329 7.29981 4.06481 7.7082 3.66091Z'
    />
  </svg>
)
export default SvgArrowRight
